export const C = {
  vio: "#8B5CF6",
  blu: "#38BDF8",
  amb: "#F59E0B",
  grn: "#22C55E",
  ros: "#F43F5E",
  lim: "#84CC16",
};

// stage index -> meaning
export const STAGES = [
  { key: "check", n: 0, name: "Check", color: C.vio, verb: "prior knowledge", time: "~3 min" },
  { key: "learn", n: 1, name: "Learn", color: C.blu, verb: "core concepts", time: "~12 min" },
  { key: "teach", n: 2, name: "Teach", color: C.amb, verb: "intuition", time: "~8 min" },
  { key: "prove", n: 3, name: "Prove", color: C.grn, verb: "proof", time: "~7 min" },
];

export const statusToIndex = (status) => {
  const map = { check: 0, learn: 1, teach: 2, prove: 3, mastered: 4 };
  return map[status] ?? 0;
};

// highlight kind -> color
export const KIND_COLOR = {
  concept: C.blu,
  example: C.amb,
  misconception: C.ros,
  prior: C.vio,
};

export const CONF = [
  { v: 1, label: "Guessing", color: C.ros },
  { v: 2, label: "Unsure", color: C.amb },
  { v: 3, label: "Fairly sure", color: C.lim },
  { v: 4, label: "Certain", color: C.grn },
];

export const RESOURCE = {
  watch: { label: "Watch", color: C.amb },
  read: { label: "Read", color: C.blu },
  play: { label: "Play", color: C.grn },
  deeper: { label: "Go deeper", color: C.vio },
};

export const WEAKNESS = {
  jargon: "Jargon",
  missingWhy: "Missing why",
  wrong: "Wrong",
  noExample: "No example",
  circular: "Circular",
  skipped: "Skipped",
};

export function timeAgo(iso) {
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function fmtTimer(sec) {
  const m = Math.floor(sec / 60).toString().padStart(2, "0");
  const s = Math.floor(sec % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
}
